import React from "react";
import { Table } from "reactstrap";

const ICTTab = ({ assets = [] }) => {
    if (assets.length === 0) {
        return <p className="text-center text-muted py-4">No ICT equipment recorded.</p>;
    }

    return (
        <Table responsive hover bordered>
            <thead style={{ backgroundColor: "#0147C8", color: "white" }}>
                <tr>
                    <th style={{ width: "50px" }}>#</th>
                    <th>Barcode</th>
                    <th>Name</th>
                    <th>Location</th>
                    <th>Acquisition Date</th>
                    <th>Condition</th>
                </tr>
            </thead>
            <tbody>
                {assets.map((a) => {
                    const condition = a.observed_condition_name || a.observed_condition || "Good";
                    return (
                        <tr key={a.id}>
                            <td className="fw-bold text-muted">{a.serialNumber || "-"}</td>
                            <td>{a.barcode || "-"}</td>
                            <td><strong>{a.name}</strong></td>
                            <td>{a.location || "-"}</td>
                            <td>{a.acquisition_date ? new Date(a.acquisition_date).toLocaleDateString() : "-"}</td>
                            <td>{condition}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default ICTTab;